import { IncentiveOffer, IncentiveOffersSummary } from 'modules/incentivesMarket/types';

const calculateOffersSummary = (
  offers: IncentiveOffer[]
): IncentiveOffersSummary => {
  const offersCount = offers.length;
  const unitsCount = offers.reduce(
    (acc, offer) => acc + offer.unitsCount.total,
    0
  );
  const totalAmount = offers.reduce(
    (acc, offer) => acc + offer.unitsCount.total * offer.unitPrice,
    0
  );

  return { offersCount, unitsCount, totalAmount };
};

export default calculateOffersSummary;
